import React, { useState } from 'react';
import '../styles/FAQAccordion.css';

const faqs = [
  {
    question: 'What is ABBASS Global Properties?',
    answer: 'We\'re a boutique real estate firm helping international buyers invest in Dubai property with end-to-end support—from strategy to settlement.'
  },
  {
    question: 'Can foreigners buy property in Dubai?',
    answer: 'Yes. Dubai has designated freehold areas where foreigners can own property outright, with full legal rights.'
  },
  {
    question: 'What types of properties can I buy in Dubai?',
    answer: 'Apartments, villas, townhouses, commercial units, and off-plan developments—tailored to your goals.'
  },
  {
    question: 'Is now a good time to invest in Dubai?',
    answer: 'Yes. Dubai offers strong rental yields, population growth, and no property taxes—making it a smart time to enter.'
  },
  {
    question: 'How does the buying process work with you?',
    answer: 'We handle everything: strategy, property sourcing, negotiation, contracts, and post-settlement support.'
  },
  {
    question: 'Do I need to visit Dubai to buy?',
    answer: 'No. We support full remote purchases via digital inspections, e-signatures, and local representation.'
  },
  {
    question: 'What\'s the minimum budget to buy in Dubai?',
    answer: 'Prices start from approx. AED 600,000 (~AUD 250,000), depending on location and property type.'
  },
  {
    question: 'What taxes or fees apply?',
    answer: 'No income or capital gains tax. You\'ll pay a 4% DLD fee, agent commission, and basic admin fees.'
  }
];

const FAQAccordion = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = idx => setOpenIndex(openIndex === idx ? null : idx);
  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, idx) => (
          <div className={`faq-item${openIndex === idx ? ' open' : ''}`} key={faq.question}>
            <button className="faq-question" onClick={() => toggle(idx)}>
              {faq.question}
              <span className={`faq-arrow${openIndex === idx ? ' open' : ''}`}>▼</span>
            </button>
            <div className="faq-answer-wrapper" style={{ maxHeight: openIndex === idx ? 200 : 0 }}>
              <div className="faq-answer">{faq.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQAccordion; 